<template>
    <div style="padding-top:30px;">
        <div class="page-titles p-3 border-bottom">
            <h3 class="text-themecolor">General Partner
                <span class="card-subtitle" v-if="user.profile">{{user.profile.first_name+' '+user.profile.last_name}} ({{user.email}})</span>
                <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/users/general-partners')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">General Partners</span></button>
            </h3>
        </div>
        <div class="container-fluid p-0 pta-gp-weightings" style="font-size: 0.75em;">
            <div class="row">
                <div class="col-12 col-sm-8">
                    <div class="card">
                        <div class="card-body p-4">
                            <div class="row">
                                <user-sidebar menu="sales-pipeline" :id="id"></user-sidebar>
                                <div class="col-9 col-sm-9">
                                     <h4 class="card-title">Sales History</h4>

                                      <div class="pta-timeline" v-if="sales_pipeline">
                                        <div class="pta-timeline-container" v-for="sales_pipeline_entry in sales_pipeline">
                                          <div class="pta-timeline-content">
                                            <h2>{{ sales_pipeline_entry.headline }}</h2>
                                            <p>{{ sales_pipeline_entry.info }}</p>
                                          </div>
                                        </div>
                                        <!-- <div class="pta-timeline-container pta-timeline-right">
                                          <div class="pta-timeline-content">
                                            <h2>Investors generated</h2>
                                            <p>Timestamp: </p>
                                          </div>
                                        </div>
                                        <div class="pta-timeline-container pta-timeline-left">
                                          <div class="pta-timeline-content">
                                            <h2>Email 1 // Investor Suitability Analysis - Investor List</h2>
                                            <p>Sent at:<br />Open at:</p>
                                          </div>
                                        </div>
                                        <div class="pta-timeline-container pta-timeline-right">
                                          <div class="pta-timeline-content">
                                            <h2>Email 2 // Investor Suitability Analysis - World Map</h2>
                                            <p>Sent at:<br />Open at:</p>
                                          </div>
                                        </div>
                                        <div class="pta-timeline-container pta-timeline-left">
                                          <div class="pta-timeline-content">
                                            <h2>Email 3 // Investor Suitability Analysis - Pie Chart</h2>
                                            <p>Sent at:<br />Open at:</p>
                                          </div>
                                        </div>
                                        <div class="pta-timeline-container pta-timeline-right">
                                          <div class="pta-timeline-content">
                                            <h2>Email 4 // Investor Suitability Analysis - Treemap</h2>
                                            <p>Sent at:<br />Open at:</p>
                                          </div>
                                        </div>
                                        <div class="pta-timeline-container pta-timeline-left">
                                          <div class="pta-timeline-content">
                                            <h2>Email 5 // Investor Suitability Analysis - Bar Chart</h2>
                                            <p>Sent at:<br />Open at:</p>
                                          </div>
                                        </div>-->
                                      </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <user-summary :user="user"></user-summary>
            </div>
        </div>
    </div>
</template>
<script>
    import userSidebar from './general-partner-sidebar'
    import userSummary from './summary'
    import switches from 'vue-switches'

    /*
• Weights assigned to different parameters (optional parameters, default value: 1)
• weights.hqcountry: HQ Country [value between 1 and 10]
• weights.hqcontinent: HQ Continent [value between 1 and 10]
• weights.geo: Preferred Geography [value between 1 and 10]
• weights.cont: Continent [value between 1 and 10]
• weights.struc: Investment Structure [value between 1 and 10]
• weights.fundtype: Preferred Fund Type [value between 1 and 10]
• weights.fundtypecat: Fund Type Category [value between 1 and 10]
• weights.lptype: LP Type [value between 1 and 10]
• weights.esg: ESG Status [value between 1 and 10]
• weights.ftf: First time fund [value between 1 and 10]
     */

    export default {
        components : { switches,userSidebar,userSummary },
        data() {
            return {
                id:this.$route.params.id,
                userForm: new Form({
                  weight_hqcountry: 2,
                  weight_hqcontinent: 2,
                  weight_geo: 10,
                  weight_cont: 10,
                  weight_struc: 1,
                  weight_fundtype: 10,
                  weight_fundtypecat: 4,
                  weight_lptype: 2,
                  weight_esg: 1,
                  weight_ftf: 1,
                },false),
                is_loading: true,
                bleft: false,
                user: '',
                investors: '',
                sales_pipeline: ''
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/account/dashboard');
            }
            this.fetchUserData();
           this.fetchSalesPipeline();
        },
        methods: {
          fetchUserData(){
            axios.get('/api/user/'+this.id)
                .then(response => response.data)
                .then(response => {
                  this.user = response.user;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error);
                  this.$router.push('/user');
                })
          },
          fetchSalesPipeline(){
            axios.get('/api/user/'+this.id+'/sales-pipeline')
                .then(response => response.data)
                .then(response => {
                  this.sales_pipeline = response;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error);
                  this.$router.push('/user');
                })
          },
          getOrientation(){
            return 'pta-timeline-left';
            this.bleft = !this.bleft;
            return this.bleft?'pta-timeline-left':'pta-timeline-right';
          }
        }
    }
</script>
<style>
.pta-gp-weightings label{
  display:block;
}
.pta-gp-weightings select option,
.pta-gp-weightings select{
  font-weight:400;
  font-size:14px;
}

/* The actual timeline (the vertical ruler) */
.pta-timeline {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.pta-timeline h2 {
  font-size:18px;
  line-height:24px;
}

/* The actual timeline (the vertical ruler) */
.pta-timeline::after {
  content: '';
  position: absolute;
  width: 6px;
  background-color: #efefef;
  top: 0;
  bottom: 0;
  left: 50%;
  margin-left: -3px;
}

/* Container around content */
.pta-timeline .pta-timeline-container {
  padding: 10px 30px;
  position: relative;
  background-color: inherit;
  width: 50%;
}

/* The circles on the timeline */
.pta-timeline .pta-timeline-container::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  right: -10px;
  background-color: #efefef;
  border: 4px solid #6278A1;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}

/* Place the container to the left */
.pta-timeline .pta-timeline-container:nth-child(even),
.pta-timeline .pta-timeline-left {
  left: 0;
}


/* Place the container to the right */
.pta-timeline .pta-timeline-container:nth-child(odd),
.pta-timeline .pta-timeline-right {
  left: 50%;
}

/* Add arrows to the left container (pointing right) */
.pta-timeline .pta-timeline-container:nth-child(even)::before,
.pta-timeline .pta-timeline-left::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 16px;
  width: 0;
  z-index: 1;
  right: 20px;
  border: medium solid #efefef;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent #efefef;
}

/* Add arrows to the right container (pointing left) */
.pta-timeline .pta-timeline-container:nth-child(odd)::before,
.pta-timeline .pta-timeline-right::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 16px;
  width: 0;
  z-index: 1;
  left: 20px;
  border: medium solid #efefef;
  border-width: 10px 10px 10px 0;
  border-color: transparent #efefef transparent transparent;
}

/* Fix the circle for containers on the right side */
.pta-timeline .pta-timeline-container:nth-child(odd)::after,
.pta-timeline .pta-timeline-right::after {
  left: -10px;
}

/* The actual content */
.pta-timeline .pta-timeline-content {
  padding: 10px 20px;
  background-color: #efefef;
  position: relative;
  border-radius: 6px;
}
.pta-timeline-content p{
  font-size:14px;
}

/* Media queries - Responsive timeline on screens less than 600px wide */
@media screen and (max-width: 600px) {
  /* Place the timelime to the left */
  .pta-timeline::after {
    left: 31px;
  }

  /* Full-width containers */
  .pta-timeline .pta-timeline-container {
    width: 100%;
    padding-left: 70px;
    padding-right: 25px;
  }

  /* Make sure that all arrows are pointing leftwards */
  .pta-timeline .pta-timeline-container::before {
    left: 60px;
    border: medium solid #efefef;
    border-width: 10px 10px 10px 0;
    border-color: transparent #efefef transparent transparent;
  }

  /* Make sure all circles are at the same spot */
  .pta-timeline .pta-timeline-container:nth-child(even)::after,
  .pta-timeline .pta-timeline-left::after, .right::after {
    left: 15px;
  }

  /* Make all right containers behave like the left ones */
  .pta-timeline .pta-timeline-right {
    left: 0%;
  }
}
</style>
